import styled from "@emotion/styled";

import { theme } from "../../Internals/ThemeProvider/CandyTheme/ThemeShorthand";

export const FormName = styled.span(props => ({
    fontSize: "20px",
    color: theme(props).typography.primary.color,
}));

export const PeriodDescription = styled.span();

export const Cards = styled.div({
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    flexWrap: "wrap",
    rowGap: "4px",
    columnGap: "8px",
});

export const BaseCard = styled.span(_ => ({
    display: "inline-flex",
    minHeight: "23px",
    flexDirection: "row",
    alignItems: "center",
    columnGap: "4px",
}));

export const TextInCard = styled.span({});

export const HintWithLink = styled.span(props => ({
    a: {
        color: theme(props).cardActualInfo.linkColor,
    },
}));

export const LinkInfoCard = styled(BaseCard)(props => ({
    color: theme(props).cardActualInfo.linkColor,
}));

export const CalendarInfoCard = styled(BaseCard)(() => ({
    marginTop: "8px",
    border: "none",
}));

export const BaseRelevanceFormCard = styled(BaseCard)(() => ({
    borderRadius: "4px",
    padding: "0px 4px",
}));

export const NotRelevanceFormCard = styled(BaseRelevanceFormCard)(props => ({
    backgroundColor: theme(props).cardActualInfo.backgroundRedColor,
    border: `1px solid ${theme(props).cardActualInfo.backgroundRedColor}`,
}));

export const RelevanceFormCard = styled(BaseRelevanceFormCard)(props => ({
    backgroundColor: theme(props).cardActualInfo.backgroundLightGreenColor,
    border: `1px solid ${theme(props).cardActualInfo.backgroundLightGreenColor}`,
}));

export const RelevanceFormWithConditionCard = styled(BaseRelevanceFormCard)(props => ({
    border: `1px solid ${theme(props).cardActualInfo.backgroundDarkGreenColor}`,
}));
